import ReceiptHiddenSection from './ReceiptHiddenSection';
import {
  KoobBadge,
  KoobInputLabel,
  KoobInputNumber,
  KoobInputText,
  KoobParagraph,
  KoobSelectCurrency,
  KoobTitle,
} from '@koob/ui';
import { useTranslation } from 'react-i18next';

export default function ReceiptCurrencyConversion({
  sourceCurrency,
  currencies = [],
  value = {},
  onUpdate,
  disabled = false,
}) {
  const { t } = useTranslation('trips');
  const { targetCurrency, exchangeRate } = value || {};

  return (
    <ReceiptHiddenSection className="mt-3">
      <KoobTitle size="md">
        <div className="flex space-x-3 items-center">
          <div>{t('receipt.currencyConversion.title')}</div>
          <KoobBadge>{t('receipt.optional')}</KoobBadge>
        </div>
      </KoobTitle>

      <KoobParagraph size="sm">
        {t('receipt.currencyConversion.description')}
      </KoobParagraph>

      <div className="flex space-x-3 mt-3">
        <KoobInputLabel label={t('receipt.currencyConversion.sourceCurrency')}>
          <KoobInputText type="text" value={sourceCurrency} disabled />
        </KoobInputLabel>

        <KoobSelectCurrency
          label={t('receipt.currencyConversion.targetCurrency')}
          onChange={(val) => {
            const currencyCode = typeof val === 'object' ? val?.value : val;
            onUpdate?.('targetCurrency', currencyCode);
          }}
          currencies={currencies}
          value={targetCurrency}
          disabled={disabled}
        />

        <KoobInputLabel label={t('receipt.currencyConversion.exchangeRate')}>
          <KoobInputNumber
            placeholder={t(
              'receipt.currencyConversion.exchangeRatePlaceholder',
            )}
            min={0}
            value={exchangeRate}
            onValueChange={(value) => onUpdate?.('exchangeRate', value ?? '')}
            disabled={disabled}
          />
        </KoobInputLabel>
      </div>
    </ReceiptHiddenSection>
  );
}
